
<template>
  <div>
    <m1Header></m1Header>
    <router-view :key="router"></router-view>
    <div class="clear"></div>
    <div class="mt"></div>
    <m1-footer></m1-footer>
  </div>
</template>

<script type="text/ecmascript-6">
import m1Header from "@components/header/m1_header";
import m1Footer from "@components/footer/m1_footer.vue";
export default {
  components: {
    m1Footer,
    m1Header,
  },
  data() {
    return {};
  },
  computed: {
    router: function() {
      return this.$route.name;
    }
  },
};
</script>